import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';

@Injectable()
export class CertinomisGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {

    // @ts-ignore
    let path = route.routeConfig.path;

    console.log(path);
    if (path === 'certinomis') {
      return true;
    }

    // Logique pour contrôler l'accès
    // Ici, nous autorisons toujours l'accès à /certinomis
    this.router.navigate(['/certinomis']);
    return false; // Bloque toute autre navigation et redirige
  }
}
